import adminPortalCss from "../../css/adminportal.module.css";
import  { ReactComponent as CompleteECLIcon }  from '../../assets/icons/completeECL.svg'

const MemberCreationProgressBar = ({
    ActiveStage,
    setActiveStage,
    }) => {

        var outerBadge1 = `${adminPortalCss.numBadge} ${adminPortalCss.inactiveBadgeBgClr} ${adminPortalCss.badge}`
        var innerBadge1 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.innerBadgeBgClr}`
        var badgeConnecter1 = `${adminPortalCss.numbConnterStart2} ${adminPortalCss.inactiveBadgeBgClr}`
        var content1 = 1

        var outerBadge2 = `${adminPortalCss.numBadge} ${adminPortalCss.inactiveBadgeBgClr} ${adminPortalCss.badge}`
        var innerBadge2 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.innerBadgeBgClr}`
        var badgeConnecter2 = `${adminPortalCss.numbConnterStart2} ${adminPortalCss.inactiveBadgeBgClr}`
        var content2 = 2

        var outerBadge3 = `${adminPortalCss.numBadge} ${adminPortalCss.inactiveBadgeBgClr} ${adminPortalCss.badge}`
        var innerBadge3 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.innerBadgeBgClr}`
        var badgeConnecter3 = `${adminPortalCss.numbConnterStart3} ${adminPortalCss.inactiveBadgeBgClr}`
        var content3 = 3

        if (ActiveStage === 1) {
                outerBadge1 = `${adminPortalCss.numBadge} ${adminPortalCss.activeBadegClr} ${adminPortalCss.badge}`;
                innerBadge1 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.innerBadgeBgClr}`
                badgeConnecter1 = `${adminPortalCss.numbConnterStart1} ${adminPortalCss.activeBadgeBgClr}`
                content1 = 1
            } 
            else if (ActiveStage === 2) {
                outerBadge1 = `${adminPortalCss.numBadge} ${adminPortalCss.completeBadgeClr} ${adminPortalCss.badge}`;
                innerBadge1 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.completeBadgeClr}`
                badgeConnecter1 = `${adminPortalCss.numbConnterStart1} ${adminPortalCss.completedBadgConnecterClr}`
                content1 = <CompleteECLIcon />

                outerBadge2 =  `${adminPortalCss.numBadge} ${adminPortalCss.activeBadegClr} ${adminPortalCss.badge}`
                innerBadge2 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.innerBadgeBgClr}`
                badgeConnecter2 = `${adminPortalCss.numbConnterStart2} ${adminPortalCss.middleActiveBar} `

                badgeConnecter3 = `${adminPortalCss.numbConnterStart3} ${adminPortalCss.lastInActiverBar} `
            } 
            else if (ActiveStage === 3) {
                outerBadge1 = `${adminPortalCss.numBadge} ${adminPortalCss.completeBadgeClr} ${adminPortalCss.badge}`;
                innerBadge1 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.completeBadgeClr}`
                badgeConnecter1 = `${adminPortalCss.numbConnterStart1} ${adminPortalCss.fullCompletedBadgConnecterClr} `
                content1 = <CompleteECLIcon />

                outerBadge2 =  `${adminPortalCss.numBadge} ${adminPortalCss.completeBadgeClr} ${adminPortalCss.badge}`
                innerBadge2 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.completeBadgeClr}`
                badgeConnecter2 = `${adminPortalCss.numbConnterStart2} ${adminPortalCss.fullCompletedBadgConnecterClr} `
                content2 = <CompleteECLIcon />

                outerBadge3 = `${adminPortalCss.numBadge} ${adminPortalCss.activeBadegClr} ${adminPortalCss.badge}`
                innerBadge3 = `${adminPortalCss.numBadgeInner} ${adminPortalCss.innerBadgeBgClr}`
                badgeConnecter3 = `${adminPortalCss.numbConnterStart3} ${adminPortalCss.lastConnecter} `
            } 

    return (

        <div className={adminPortalCss.numBadgeMainContainer}>
            <div className={adminPortalCss.numberContainer}>
                <div onClick={ () => {} } key={1} className={`${adminPortalCss.numBadgeContainer} ${adminPortalCss.badgeContainerOne}`}>
                    <div className={badgeConnecter1}></div>
                    <div className={`${outerBadge1} ${adminPortalCss.badge}`} >
                        <div className={innerBadge1}>{content1}</div>
                    </div>
                    <div className={`${adminPortalCss.numberText} ${adminPortalCss.numberText1}`}>General details</div>
                </div>
                <div onClick={ () => {} } key={2} className={`${adminPortalCss.numBadgeContainer} ${adminPortalCss.badgeContainerTwo}`}>
                    <div className={badgeConnecter2}></div>
                    <div className={`${outerBadge2} ${adminPortalCss.badge}`}>
                        <div className={innerBadge2}>{content2}</div>
                    </div>
                    <div className={`${adminPortalCss.numberText} ${adminPortalCss.numberText2}`}>Select Companies</div>
                </div>
                <div onClick={ () => {} } key={3} className={`${adminPortalCss.numBadgeContainer} ${adminPortalCss.badgeContainerThree}`}>
                    <div className={badgeConnecter3}></div>
                    <div className={`${outerBadge3} ${adminPortalCss.badge}`}>
                        <div className={innerBadge3}>{content3}</div>
                    </div>
                    <div className={`${adminPortalCss.numberText} ${adminPortalCss.numberText3}`}>Responsibilities</div>
                </div>
            </div>
        </div>
    );
};

export default MemberCreationProgressBar;